import { useAtom } from '@reatom/npm-react'
import styled from 'styled-components'

import { AsyncStateN } from '@blade/std-lib'
import {
  premiumCurrenciesStateAtom,
  UserPremiumList,
  userPremiumTabAtom,
} from '@root/features/premium'
import { PremiumPurchaseTable } from '@root/features/premium/purchase-history/ui/premium-purchase-table'

import { PremiumPageContentHeading } from './premium-page-content-heading'
import { PremiumPageContentTabs } from './premium-page-content-tabs'

export const PremiumPageContent: React.FC = () => {
  const [currenciesState] = useAtom(premiumCurrenciesStateAtom)
  const noPremiumCurrencies = AsyncStateN.matchWaiting(currenciesState, {
    Success: (currencies) => currencies.length === 0,
    Error: () => true,
    Waiting: () => false,
  })
  const [tab] = useAtom(userPremiumTabAtom)

  const renderContent = () => {
    if (tab === 'purchase-history') {
      return <PremiumPurchaseTable />
    }
    return <UserPremiumList />
  }

  return (
    <Root data-empty={noPremiumCurrencies}>
      <PremiumPageContentHeading />
      <PremiumPageContentTabs />
      {renderContent()}
    </Root>
  )
}

const Root = styled.div`
  border: 1px solid var(--background-3);
  background: var(--background-1);

  display: grid;
  grid-template-rows: auto auto minmax(0, 1fr);
  overflow: hidden;
  min-height: 0;
  height: 100%;

  border-radius: 12px;

  // TODO: Ivan - uncomment some time later
  /* &[data-empty='true'] {
    grid-template-rows: auto 1fr;
  } */
`
